module.exports = __webpack_public_path__ + "img/inclusivity.3b2cf66b.svg";